import { buildClassesHook } from '../../helpers/styles';

export const useClasses = buildClassesHook({
    rowTop2: {
        marginTop: '2em'
    }
});
